microflow.controller("tabsCtrl", [
  "$scope",
  function ($scope) {
    var tab = "default";

    $scope.setTab = function (tabId) {
      tab = tabId;
      document.dispatchEvent(new Event("resize", { 'bubbles': true }));
    };
    $scope.isActivated = function (tabId) {
      return tab === tabId;
    };
  }
]);
 